import demandbase_country_map from './demandBaseCountryMap'
import ppi_map from './ppiMap'
import field_label_map from './fieldLabelMap'

export const DEMANDBASE_COUNTRY_MAP = demandbase_country_map
export const PPI_MAP = ppi_map
export const FIELD_LABEL_MAP = field_label_map

export const MKTO_SUPP_LIST = {
    "_mkto_trk": "",
    "munchkinId" : "",
    "Privacy" : "",
    "clientIPAddress" : ""
}

export const YES_NO_INPUTS = [
    "Email_Blast_OK__c",
    "OK_to_Call__c"
]

export const FIELD_GOOGLE_SUPP_LIST = [
    "GCLID",
    "GAClientID"
]

export const ABBREVIATION_TO_COUNTRY = {
    "Australia" : "au",
    "Canada" : "ca",
    "China" : "cn",
    "India" : "in",
    "USA" : "us"
}

export const COUNTRIES_WITH_ZIP = [
    "France",
    "Germany",
    "Italy",
    "Spain",
    "United Kingdom",
    "USA"
]

export const APJ_PRIVACY_COUNTRIES = [
    "Japan"
]

export const EMBARGOED_COUNTRIES = [
    "Cuba",
    "Iran",
    "Libya",
    "North Korea",
    "Sudan",
    "Syria Republic"
]

export const GDPR_COUNTRIES = [
    "Austria",
    "Australia",
    "Belgium",
    "Brazil",
    "Bulgaria",
    "Canada",
    "China",
    "Costa Rica",
    "Croatia",
    "Cyprus",
    "Czechia",
    "Denmark",
    "Estonia",
    "Finland",
    "France",
    "Germany",
    "Ghana Republic",
    "Gibraltar",
    "Greece",
    "Guadeloupe",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "Ireland",
    "Israel",
    "Italy",
    "Japan",
    "Latvia",
    "Lichtenstein",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Malta",
    "Monaco Principaute",
    "Netherlands",
    "New Zealand",
    "Norway",
    "Poland",
    "Portugal",
    "Romania",
    "Russia",
    "Senegal Republique",
    "Serbia",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "South Korea",
    "Spain",
    "Sweden",
    "Switzerland",
    "Tunisia",
    "Turkey",
    "Ukraine",
    "United Kingdom",
    "Vietnam"
]


/**
 * these value are unique and should be loaded at run time, not pre-filled
 * @type {string[]}
 */
export const PREFILL_EXCLUSIONS = [
    "userAgent",
    "clientIPAddress",
    "referrerURL",
    "programName",
    "source",
    "reason",
    "lookupField",
    "InteractionStage",
    "leadStatus",
    "Record_Processing_Type__c",
    "Comments__c",
    "_mkto_trk",
    "munckinId",
    "Registration_Date__c",
    "Sales_Contact_Requested__c",
    "Primary_Product_Interest__c",
    "UTM_Campaign__c",
    "UTM_Content__c",
    "UTM_Domain__c",
    "UTMMasterCode",
    "UTM_Medium__c",
    "UTM_Program_Code__c",
    "UTM_Source__c",
    "UTM_Term__c",
    "UTM_Campaign_Number__c",
    "UTM_Last_Campaign_Session__c",
    "UTM_Referral_Sources__c",
    "UTM_Session__c",
    "UTM_Session_Date__c",
    "webPage"
]

